module.exports = __webpack_public_path__ + "img/cf5b557.png";